import React, {useEffect, useState} from "react";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../../examples/Footer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import {
    IconButton,
    Menu,
    MenuItem
} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GenericForm from "../dialog/genericform";
import {getFields} from "../dialog/formfields";
import {useNavigate} from "react-router-dom";
import DataTableConfig from "../Tables/DataTableConfig";
import tableData from "../tabledata";
import useConfigApi from "../utils/configapi";
import Endpoints from "../utils/endpoints";
import toast from "react-hot-toast";

function GroupConfig() {

    const { groupConfigColumns } = tableData();
    const { groupConfigFields } = getFields();
    const [groupConfig, setGroupConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create GroupConfig");
    const navigate = useNavigate();
    const api = useConfigApi();





    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveRowIndex(index);
    };
    const openModal = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create GroupConfig");
    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRowIndex(null);
    };

    const handleActionClick = (action: string, item) => {
        const row = groupConfig[activeRowIndex];
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogData(row);
            setDialogTitle("View GroupConfig");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit GroupConfig");
            setDialogData(row);
        } else if(action === 'viewDevices') {
            navigate(`/device-config/${item.grpId}`);
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete GroupConfig");
            setDialogData(row);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        console.log("Submitted data:", formData, dialogMode);
        // Call your API here
        if (dialogMode === "create") {
            // Handle create logic here
            api.post(Endpoints.groups.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Group config successfully created.");
                    fetchGroupConfigs(); // Fetch the latest data after creation
                })
                .catch((error) => {
                    const responseMessage = error?.response?.data?.responseMessage;
                    if (responseMessage.includes("duplicate key value") &&
                        responseMessage.includes("grp_config_name")) {
                        toast.error("Group name already exists.");
                    } else {
                        toast.error("Internal error occurred while creating.");
                    }

                });
        } else if (dialogMode === "edit") {
            api
              .put(Endpoints.groups.createOrUpdate, formData)
              .then(({ data }) => {
                toast.success("Group config successfully updated.");
                setModalOpen(false);

                const updated = data?.data ?? formData; // prefer backend echo
                const key = updated?.grpId ?? dialogData?.grpId;

                // In-place patch: keep row position and preserve computed cells like `action`
                setGroupConfig((prevRows) =>
                  prevRows.map((row) =>
                    row.grpId === key
                      ? { ...row, ...updated } // spread existing row first to keep `action`
                      : row
                  )
                );
              })
              .catch((error) => {
                const responseMessage = error?.response?.data?.responseMessage;
                if (
                  responseMessage.includes("duplicate key value") &&
                  responseMessage.includes("grp_config_name")
                ) {
                  toast.error("Group name already exists.");
                } else {
                  toast.error("Internal error occurred while updating.");
                }
              });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.grpId) {
            toast.error("Missing group ID for deletion.");
            return;
        }
        api.delete(Endpoints.groups.deleteById(formData.grpId))
            .then(() => {
                toast.success("Group config successfully deleted.");
                fetchGroupConfigs();
            })
            .catch(() => {
                toast.error("Error deleting group config.");
            });
    };

    useEffect(() => {
        fetchGroupConfigs();
    },[]);

    const fetchGroupConfigs = () => {
        api.get(Endpoints.groups.getAll(false))
            .then((response) => {
                const data = response?.data.data || [];

                const modifiedData = data.map((item, index) => {
                    const action = (
                        <>
                            <MDTypography
                                display="inline"
                                color="info"
                                sx={{
                                    borderBottom: "1px solid #2196F3",
                                    paddingBottom: "1px",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                    fontWeight: "light",
                                    cursor: "pointer",
                                    marginRight: 1,
                                }}
                                onClick={() => handleActionClick("viewDevices", item)}
                            >
                                View Devices
                            </MDTypography>

                            <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                                <MoreHorizIcon />
                            </IconButton>
                        </>
                    );

                    return { ...item, action };
                });

                setGroupConfig(modifiedData);
            })
            .catch((error) => {
                console.log(error);
                toast.error("Error while fetching records.");
            });
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={6} mb={3}>
                <Grid container spacing={3} justifyContent="center">
                    <Grid container justifyContent="flex-end">
                        <MDButton
                            variant="gradient"
                            onClick={openModal}
                            color="info"
                            sx={{ mr: 3, mb: 1.5 }}
                        >
                            Create New Group
                        </MDButton>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <DataTableConfig
                            table={{ columns : groupConfigColumns, rows : groupConfig }}
                            showTotalEntries={true}
                            isSorted={true}
                            noEndBorder
                            entriesPerPage={true}
                            canSearch={true}
                        />
                    </Grid>
                </Grid>
            </MDBox>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
            >
                <MenuItem onClick={() => handleActionClick("Edit")}>
                    <IconButton size="small">
                        <EditIcon fontSize="small" />
                    </IconButton>Edit</MenuItem>
                <MenuItem onClick={() => handleActionClick("Delete")}>
                    <IconButton size="small" color="error">
                        <DeleteIcon fontSize="small" />
                    </IconButton>Delete</MenuItem>
            </Menu>
            <GenericForm
                open={isModalOpen}
                handleClose={closeModal}
                title={dialogTitle}
                fields={groupConfigFields}
                onSubmit={handleDialogSubmit}
                onDelete={handleDialogDelete}
                initialData={dialogData}
                mode={dialogMode}
                useDialog={true}
                maxWidth="sm"
            />
            <Footer />
        </DashboardLayout>
    );
}

export default GroupConfig;

